"use client";

import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { formatNoOfReviews } from "@/lib/utils";
import { cn } from "@/lib/utils";
import CustomerReviews from "./customer_reviews";

interface ProductTabsProps {
  description: string;
  noOfReviews: number;
}

export default function ProductTabs({ description, noOfReviews }: ProductTabsProps) {
  // Split description into paragraphs (assuming it might be a long text)
  // For now, we'll display it as-is, but you can enhance this to split by sentences
  // also implment a preload thing from react that preloads the data before you switch tabs
  const descriptionParagraphs = description.split(/\n\n+/).filter((p) => p.trim());

  const customerReviews = [
    {
      customer_name: "John Doe",
      rating: 4.5,
      date: "Oct 30, 2025",
      review: "This is a review",
    },
    {
      customer_name: "Jane Doe",
      rating: 3.5,
      date: "Oct 30, 2025",
      review: "This is a review",
    },
    {
      customer_name: "John Doe",
      rating: 4.5,
      date: "Oct 30, 2025",
      review: "This is a review",
    },
    {
      customer_name: "Jane Doe",
      rating: 4,
      date: "Oct 30, 2025",
      review: "This is a review",
    },
    {
      customer_name: "John Doe",
      rating: 4.5,
      date: "Oct 30, 2025",
      review: "This is a review",
    },
  ];

  return (
    <div className=''>
      <Tabs defaultValue='about' className='w-full'>
        <TabsList className='h-auto w-full gap-0 rounded-none border-b border-gray-200 bg-transparent p-0'>
          <TabsTrigger
            value='about'
            className={cn(
              "data-[state=active]:bg-link-primary/5 border-x-0 border-t-0 data-[state=active]:shadow-none",
              "border-b-2 border-transparent px-0 pb-3 text-sm font-medium uppercase",
              "data-[state=active]:border-link-primary data-[state=active]:text-link-primary",
              "text-text-title/60 data-[state=inactive]:hover:text-text-title/80",
              "rounded-none transition-colors"
            )}
          >
            ABOUT THE PRODUCT
          </TabsTrigger>
          <TabsTrigger
            value='reviews'
            className={cn(
              "data-[state=active]:bg-link-primary/5 border-x-0 border-t-0 data-[state=active]:shadow-none",
              "ml-6 border-b-2 border-transparent px-0 pb-3 text-sm font-medium uppercase",
              "data-[state=active]:border-link-primary data-[state=active]:text-link-primary",
              "text-text-title/60 data-[state=inactive]:hover:text-text-title/80",
              "rounded-none transition-colors"
            )}
          >
            CUSTOMER REVIEWS ({formatNoOfReviews(noOfReviews)})
          </TabsTrigger>
        </TabsList>
        <TabsContent value='about' className='mt-6'>
          <h3 className='text-text-title mb-4 text-2xl font-semibold'>Product Overview</h3>
          {descriptionParagraphs.length > 0 ? (
            descriptionParagraphs.map((paragraph, index) => (
              <p key={index} className='text-text-title/70 mb-4 text-sm leading-relaxed last:mb-0'>
                {paragraph.trim()}
              </p>
            ))
          ) : (
            <p className='text-text-title/70 text-sm leading-relaxed'>{description}</p>
          )}
        </TabsContent>
        <TabsContent value='reviews' className='scrollbar-hide mt-6 max-h-[600px] space-y-4 overflow-y-auto'>
          {customerReviews.map((item) => (
            <CustomerReviews key={item.customer_name} {...item} />
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
